module.exports = __webpack_public_path__ + "static/efb58ff9-b095-4ac4-bdc8-41209ecda0f7-627aa083ba2f5b9f949d29ddde858d16.webp";